<template>
  <div
    v-if="showModal"
    id="loading-modal"
  >
    <div id="spinner-container">
      <div
        class="spinner-border"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingModal",
  computed: {
    showModal(){
      return this.$store.getters['loading/requestCount'] !== 0;
    }
  }

}
</script>

<style lang="scss" scoped>
    @import '../../sass/vars';
    #loading-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        // background-color: #fafafa;
        background-color: #000000;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 1060;
        animation: modal-fade 300ms ease forwards;
    }

    #spinner-container {
        text-align: center;
        padding-top: 50vh;
    }

    .spinner-border {
        color: $green;
    }

    @keyframes modal-fade {
        to {
            opacity: .75;
        }
    }

</style>
